<template>
  <div style="position: absolute; top: 0; width: 100%; height: 100%; background: #f0f2f5">
    <pcHeaders></pcHeaders>

    <div class="cen">
      <div class="w">
        <div class="headBox">
          <div class="leftBox">
            <img
              v-if="courseInfo.cimage !== '' && courseInfo.cimage !== null"
              style="width: 253px; height: 206px"
              :src="courseInfo.cimage"
              @error="handleError"
              alt="安徽职业与成人教育学习网"
            />
            <div
              v-else
              style="position: relative; display: flex; justify-content: center; align-items: center; width: 253px; height: 206px"
            >
              <img
                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
                src="../../../assets/indexImg/noimg.png"
                alt="安徽职业与成人教育学习网"
              />
              <div
                style="
                  position: relative;
                  z-index: 11;
                  font-size: 15px;
                  font-family: kaiti;
                  text-align: center;
                  padding: 0 10px;
                  font-weight: bold;
                  color: #355fd9;
                "
              >
                {{ courseInfo.cname }}
              </div>
            </div>
          </div>
          <div class="rightBox">
            <div style="font-size: 18px">{{ courseInfo.cname }}</div>
            <div class="mt10" style="color: #ff6c4c; font-size: 16px">
              {{ courseInfo.codeName }} &emsp; ￥{{ courseInfo.cprice }} &emsp; {{ courseInfo.ccredithour }}学时
            </div>
            <div class="mt10">
              培训方式 :
              {{ courseInfo.cmode == '01' ? '在线' : courseInfo.cmode == '02' ? '面授' : courseInfo.cmode == '03' ? '混合' : '外派' }}
            </div>
            <div class="mt10 textOver" :title="courseInfo.cdesc">课程介绍 :{{ courseInfo.cdesc }}</div>

            <div class="goumBtn" @click="purchase" v-if="classInfo.classEnrolStatus == '02' && classInfo.timeFlag == '02'">购买</div>

            <div class="mt10">学习时间:{{ courseInfo.cstarttime }} - {{ courseInfo.cendtime }}</div>
          </div>
        </div>

        <div class="courseList">
          <div class="courseHead">
            <div><img style="margin-top: 5px" src="../../../assets/images/02_03.png" alt="安徽职业与成人教育学习网" /></div>
            <div style="margin-left: 5px">课程章节</div>
          </div>

          <div class="courseTable">
            <div class="leftBox">
              <el-table :data="courseList" height="318" style="width: 100%">
                <el-table-column label="课程名称" width="380" align="center">
                  <template slot-scope="scope">
                    <span style="color: #427dc3">第{{ scope.$index + 1 }}节：</span>{{ scope.row.CW_NAME }}
                  </template>
                </el-table-column>
                <el-table-column prop="CREDITNUM" label="学时" align="center"> </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <div v-if="courseInfo.isAudition == '02' && scope.$index == 0" style="display: flex; justify-content: center">
                      <div style="color: #ff9f53; cursor: pointer" @click="shiTi(scope.row)">试听</div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="videoBox" v-if="courseInfo.isAudition == '02'" style="position: relative">
              <!-- <img
                style="position: absolute; top: 10px; right: 30px; z-index: 99999; width: 102px; height: 31px"
                src="../../../assets/indexImg/videoLogo.png"
                alt="安徽职业与成人教育学习网"
              /> -->
              <div id="videoPlayer1" style="width: 700px !important;height: 318px !important;" class="vvideoBox" muted></div>
            </div>
            <div class="videoBox" v-else>
              <!-- <img class="videoBox" src="../../../assets/images/def-st.jpg" alt="安徽职业与成人教育学习网" /> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <pcBottom></pcBottom>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import pcHeaders from '../../component/head.vue';
import pcBottom from '../../component/bottom.vue';
import { getCourseDetail } from '@/api/lsitFs.js';
import { doShoppingCartZG } from '@/api/car.js';
import 'xgplayer';
import hlsjsPlayer from 'xgplayer-hls.js';
import Player from 'xgplayer';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    pcHeaders,
    pcBottom
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        {
          charset: 'utf-8'
        },
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1.0,minimum-scale=1.0, maximum-scale=1.0, user-scalable=no'
        }
      ]
    };
  },
  data() {
    // 这里存放数据
    return {
      courseInfo: {}, //班级数据
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      options: {
        autoplay: true, // 设置自动播放
        muted: true, // 设置了它为true，才可实现自动播放,同时视频也被静音 （Chrome66及以上版本，禁止音视频的自动播放）
        preload: 'auto', // 预加载
        controls: true // 显示播放的控件
      },
      total: 0,
      defaultImageUrl: require('../../../assets/images/noimg.png'),
      courseList: [], //课程列表
      player: null,
      classInfo: {}, //班级数据
      title: ''
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    handleError(event) {
      event.target.src = this.defaultImageUrl;
    },
    //购买
    purchase() {
      //非整体报名
      if (this.classInfo.isClassApply !== '02') {
        this.$router.push({
          path: '/purchase',
          query: {
            id: this.classInfo.classId
          }
        });
      } else {
        //整体报名直接加入购物车
        doShoppingCartZG({ classId: this.classInfo.classId }).then(res => {
          if (res.data.data.code == '1') {
            this.$message({
              message: '添加购物车成功！',
              duration: '1000',

              type: 'success'
            });
            this.$router.push('/car');
          } else {
            this.$message({
              message: res.data.data.msg,
              duration: '1000',

              type: 'warning'
            });
          }
        });
        return false;
      }
    },
    getVideo(videoUrl) {
      if (this.player !== null) {
        this.player.destroy('videoPlayer1');
      }
      if (videoUrl.isZjw == '1' || videoUrl.isYlx == '1') {
        this.player = new Player({
          id: 'videoPlayer1',
          autoplay: true,
          playsinline: true,
          url: videoUrl.LAUNCH,
          progressDisabled: true
        });
      } else {
        // 判断视频源是否是 m3u8 格式
        if (/\.m3u8$/.test(videoUrl.LAUNCH)) {
          this.player = new hlsjsPlayer({
            id: 'videoPlayer1',
            autoplay: true,
            playsinline: true,
            url: videoUrl.LAUNCH,
            progressDisabled: true
          });
        } else {
          let url = videoUrl.LAUNCH + '.mp4';
          this.player = new Player({
            id: 'videoPlayer1',
            autoplay: true,
            playsinline: true,
            url: url,
            progressDisabled: true
          });
        }
      }
      let _this = this;
      _this.player.on('loadstart', function () {
      });
      _this.player.on('progress', function () {
      });
      _this.player.on('loadedmetadata', function () {
      });
      _this.player.on('canplaythrough', function () {
      });
      _this.player.on('waiting', function () {
      });
      _this.player.on('play', function () {
      });
      _this.player.on('playing', function () {
      });
      _this.player.on('pause', function () {
      });
      _this.player.on('ended', function () {
      });
      _this.player.on('error', function () {
        console.log('加载错误');
      });
      _this.player.on('seeking', function () {
      });
      _this.player.on('seeked', function () {
      });
      _this.player.on('ratechange', function () {
      });
      _this.player.on('timeupdate', function (e) {
        if (_this.player.currentTime >= 300) {
          _this.$message.error('试听5分钟结束，请购买完整课程进行学习！');
          _this.player.currentTime = 0;
          return false;
        }
      });
      _this.player.on('volumechange', function () {
        console.log('音量改变');
      });
      _this.player.on('stalled', function () {
        console.log('网速异常');
      });
    },
    getCourseDetail() {
      getCourseDetail({ courseId: this.queryParams.courseId, classId: this.queryParams.classId }).then(res => {
        this.classInfo.classId = res.data.data.classId;
        this.classInfo.classEnrolStatus = res.data.data.classEnrolStatus;
        this.classInfo.isClassApply = res.data.data.isClassApply;
        this.courseList = res.data.data.cwUrlList;
        this.$nextTick(() => {
          this.getVideo(res.data.data.cwUrlList[0]);
        });
        this.courseInfo = res.data.data.course;
        this.title = res.data.data.course.cname;
      });
    },
    shiTi(row) {
      this.getVideo(row);
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.queryParams.courseId = this.$route.query.courseId;
    this.queryParams.classId = this.$route.query.classId;
    this.classInfo.timeFlag = this.$route.query.timeFlag;
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getCourseDetail();
    // this.getVideo( this.courseList[0].LAUNCH)
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeDestroy() {
    if (this.player) {
      this.player.dispose(); //重置videojs的内部状态并移除dom
    }
  }
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.cen {
  font-family: Regular;
  display: flex;
  justify-content: center;
  padding-bottom: 50px;
  background: #f0f2f5;
  .w {
    width: 1400px;
    padding-top: 30px;
    background: #f0f2f5;
    .headBox {
      background: #fff;
      padding: 30px 20px 10px 20px;
      border: 1px solid #f2f2f3;
      overflow: hidden;
      position: relative;
      display: flex;
      .rightBox {
        margin-left: 25px;
        font-size: 12px;
        .mt10 {
          margin-top: 10px;
        }
        .textOver {
          width: 800px;
          display: -webkit-box; /* Safari */
          -webkit-line-clamp: 2; /* Safari and Chrome */
          -webkit-box-orient: vertical; /* Safari and Chrome */
          overflow: hidden;
        }
        .goumBtn {
          width: 150px;
          height: 31px;
          text-align: center;
          line-height: 31px;
          background: #ff9f53;
          color: #fff;
          -webkit-border-radius: 2px;
          -moz-border-radius: 2px;
          border-radius: 2px;
          cursor: pointer;
          margin-left: 10px;
          margin-right: 10px;
          margin-top: 10px;
        }
      }
    }
    .courseList {
      margin-top: 25px;
      .courseHead {
        display: flex;
        font-size: 20px;
      }
      .courseTable {
        margin-top: 25px;
        display: flex;
        width: 100%;
        .leftBox {
          width: 700px;
        }
        .videoBox {
          width: 700px;
          position: relative;
          height: 318px;
        }
      }
    }
  }
}
#videoPlayer1 {
  width: 700px !important;
  position: relative;
  height: 318px !important;
}
</style>
